export const onlineText = {
    en: "Network is back!",
    hi: "नेटवर्क वापस आ गया है!",
    or: "ନେଟୱାର୍କ ପୁନଃ ଚାଲୁ ହୋଇଯାଇଛି!",
    mr: "नेटवर्क पुन्हा सुरू झाले आहे!"
  };
  
  export const offlineText = {
    en: "We are facing some network issue.",
    hi: "कुछ नेटवर्क समस्या है।",
    or: "ଆମେ କିଛି ନେଟୱାର୍କ ସମସ୍ୟାର ସମ୍ମୁଖୀନ ହେଉଛୁ।",
    mr: "नेटवर्कची समस्या येत आहे"
  };
  
  export const retryText = {
    en: "Trying to connect...",
    hi: "कनेक्ट करने की कोशिश कर रहे हैं...",
    or: "ଯୋଗାଯୋଗ କରିବାକୁ ଚେଷ୍ଟା କରୁଛୁ...",
    mr: "कनेक्ट करण्याचा प्रयत्न करत आहोत..."
  };
  
  export const tryAgainText = {
    en: "Try again",
    hi: "फिर से प्रयास करें।",
    or: "ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ",
    mr: "पुन्हा प्रयत्न करा"
  };
  